export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00729.6d7f1bd7.png";